// extracted by mini-css-extract-plugin
export var addButton = "_nj-0";
export var border = "_nj-8";
export var check = "_nj-h";
export var danger = "_nj-6";
export var dropdownContainer = "_nj-1";
export var editModalBody = "_nj-j";
export var footerContainer = "_nj-i";
export var fullWidth = "_nj-a";
export var hide = "_nj-9";
export var icon = "_nj-3";
export var input = "_nj-7";
export var inputFlex = "_nj-b";
export var inputWrapper = "_nj-c";
export var manualFocus = "_nj-5";
export var optionButton = "_nj-4";
export var pillWrapper = "_nj-e";
export var pointer = "_nj-2";
export var showOverflow = "_nj-f";
export var tagsFlex = "_nj-d";
export var xButton = "_nj-g";